import { JobInterface } from '../../../interfaces/job.interface';

export class UpdateJobs {
    public static readonly type = '[JobsPlacements] Update jobs';

    constructor(public jobs: Array<JobInterface>) { }
}
